import {Domain, createEndpoint} from '@esgi/contracts';

export class foldersDomain extends Domain {
	public initDelete = createEndpoint<import('../../../../../types/esgi.accounts/features/esgi.folders/init-delete/result-with-base-response').ResultWithBaseResponse, import('../../../../../types/esgi.accounts/features/esgi.folders/init-delete/request').Request>('GET', '/v2/district-admins/modules/folders/init-delete', this.clientFactory);
}
